// extracted by mini-css-extract-plugin
module.exports = {"page":"Pages_page__2Uu1S","pagePadded":"Pages_pagePadded__2ERWg"};